(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/eurojackpot/views/pages/start-page.js') >= 0) return;  svs.modules.push('/modules/eurojackpot/views/pages/start-page.js');
(function(svs, Handlebars) {
_svs=window.svs=window.svs||{};
_svs.eurojackpot=_svs.eurojackpot||{};
_svs.eurojackpot.templates=_svs.eurojackpot.templates||{};
svs.eurojackpot.templates.start_page = Handlebars.template({"1":function(container,depth0,helpers,partials,data) {
    return "  <div id=\"ngStartPageRegion\" class=\"eurojackpot-start\">\n    <div class=\"ng-skeleton-content\">\n      <div class=\"col-xs-12 col-sm-10 col-md-4 margin-top-4\"></div>\n    </div>\n  </div>\n";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = (lookupProperty(helpers,"numbergames")||(depth0 && lookupProperty(depth0,"numbergames"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),"game-app/hammock",{"name":"numbergames","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":0},"end":{"line":7,"column":16}}})) != null ? stack1 : "");
},"useData":true});
Handlebars.partials['svs-eurojackpot-start_page'] = svs.eurojackpot.templates.start_page;
})(svs, Handlebars);


 })(window);